import { useEffect, useState } from 'react';

export function usePageForgotten(timeoutMs: number): boolean {
  const [forgotten, setForgotten] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;

    function check() {
      if (document.hidden) {
        timer = setTimeout(() => {
          setForgotten(true);
        }, timeoutMs);
      } else {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        setForgotten(false);
      }
    }

    check();
    const ac = new AbortController();
    document.addEventListener('visibilitychange', check, { signal: ac.signal });

    return () => {
      ac.abort();
      if (timer) clearTimeout(timer);
    };
  }, [timeoutMs]);

  return forgotten;
}
